var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h3", [_vm._v("Upload PDF")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "file-row" },
        [
          _c("span", { staticStyle: { "margin-left": "4px" } }, [
            _vm._v("Tag name")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.tagValueUsedForTaggedDocs,
                expression: "tagValueUsedForTaggedDocs"
              }
            ],
            staticClass: "input",
            staticStyle: { "max-width": "220px" },
            attrs: {
              type: "text",
              placeholder: "Tag (optional, e.g. invoice, spec)"
            },
            domProps: { value: _vm.tagValueUsedForTaggedDocs },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.tagValueUsedForTaggedDocs = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isSharedDoc,
                expression: "isSharedDoc"
              }
            ],
            staticClass: "input",
            staticStyle: { "max-width": "220px" },
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.isSharedDoc)
                ? _vm._i(_vm.isSharedDoc, null) > -1
                : _vm.isSharedDoc
            },
            on: {
              change: function($event) {
                var $$a = _vm.isSharedDoc,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isSharedDoc = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isSharedDoc = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isSharedDoc = $$c
                }
              }
            }
          }),
          _c("span", { staticStyle: { "margin-left": "4px" } }, [
            _vm._v("Shared Document")
          ]),
          _vm._v(" "),
          _c("p", { staticStyle: {} }),
          _vm._v(" "),
          _c("DropZone", {
            attrs: {
              formId: "uploadModal" + _vm.uid,
              paramInput: "tag",
              paramValue: _vm.tagValueUsedForTaggedDocs,
              paramInput2: "isShared",
              paramValue2: _vm.isSharedDoc,
              url: _vm.dropzoneUrl
            },
            on: { uploaded: _vm.uploadedDone }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.message
        ? _c(
            "div",
            { class: ["small"], staticStyle: { "margin-top": "8px" } },
            [_vm._v(_vm._s(_vm.message))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.docsSorted, function(d) {
        return _c("div", { key: d.id, staticClass: "doc-item" }, [
          _c("div", [
            _c("strong", [
              _vm._v(
                "\n\t\t  " +
                  _vm._s(d.fileName) +
                  " | " +
                  _vm._s(d.tag) +
                  " | " +
                  _vm._s(d.displayName) +
                  "\n\t\t  "
              ),
              d.processingStatus
                ? _c(
                    "span",
                    {
                      class: [
                        "status-badge",
                        _vm.statusClass(d.processingStatus)
                      ]
                    },
                    [
                      d.processingStatus === "Processing"
                        ? _c("span", {
                            staticClass: "spinner",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n\t\t\t" + _vm._s(d.processingStatus) + "\n\t\t  "
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "small" }, [
              _vm._v(
                "\n\t\t  " +
                  _vm._s(d.contentType) +
                  " � " +
                  _vm._s(new Date(d.uploadedAt).toLocaleString()) +
                  "\n\t\t  "
              ),
              d.tag
                ? _c("span", [_vm._v(" � "), _c("em", [_vm._v(_vm._s(d.tag))])])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                staticClass: "btn secondary",
                attrs: { href: _vm.downloadUrl(d.id), target: "_blank" }
              },
              [_vm._v("Download")]
            )
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }